let isSummaryView: boolean = false;
let backUrl : string = "";
let lidZoekenSubFunctions : boolean = false;
let payload : any = {};
let lidZoekenSubFunctionsForMember : any = {};
let formCallback = undefined;
let formConfigStore : any = {};
let currentFormConfig : any = {};

let setMemberCallback : () => void;

export class FormService {
  public static setIsSummaryView(value : boolean) {
    isSummaryView = value;
  }

  public static getIsSummaryView() : boolean {
    return isSummaryView;
  }

  public static setBackUrl(value : string) {
    backUrl = value;
  }

  public static getBackUrl() {
    return backUrl;
  }

  public static setMemberDetailsCallback(callback : () => void) {
    setMemberCallback = callback;
  }

  public static setIsInLidZoekenSubFunctions(value : boolean) {
    lidZoekenSubFunctions = value;
    if (!value) {
      lidZoekenSubFunctionsForMember = {};
    }
  }

  public static getIsInLidZoekenSubFunctions() : boolean {
    return lidZoekenSubFunctions;
  }

  public static getLidZoekenSubFunctionsForMember() {
    return lidZoekenSubFunctionsForMember;
  }

  public static setLidZoekenSubFunctionsForMember(memberDetails : any) {
    lidZoekenSubFunctionsForMember = memberDetails;
    if (setMemberCallback !== undefined) {
      setMemberCallback();
    }
  }

  public static setPayload(payloadValue : any) {
    payload = payloadValue;
  }

  public static getPayload() : boolean {
    return payload;
  }
 
  public static registerRelatedDataCallback(callbackFunction : any) {
    formCallback = callbackFunction;
  }

  public static callFormRelatedDataCallback(datasource, formName, values: any) {
    if (formCallback) {
      formCallback(datasource, formName, values);
    }
  }

  public static setFormConfig(formName, formConfig) {
    formConfigStore[formName] = formConfig;
    currentFormConfig = formConfig;
  }

  public static getFormConfig(formName) {
    return formConfigStore[formName] || {};
  }

  public static getCurrentFormConfig() {
    return currentFormConfig || {};
  }
}